module.exports = __webpack_public_path__ + "img/msg-background.508ad0ab.png";